import axios from "axios";
import {authHeader} from "../helpers/auth-header";
import {getLongIsoDate, getDate} from "../helpers/dateHelper";

export const reportServce = {
        // eslint-disable-next-line no-unused-vars
        getReport(from, to, users) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: `/api/report`,
                    params: {
                        from: getLongIsoDate(from),
                        to: getLongIsoDate(to),
                        users: users
                    },
                    headers: authHeader(),
                    data: users,
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Auszug_${getDate(from)}-${getDate(to)}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    resolve();
                }).catch(function (error) {
                    let reader = new FileReader();
                    reader.onload = () => reject(reader.result)
                    reader.readAsText(error.response.data)
                });
            });
        }
    }
;